module.exports = __webpack_public_path__ + "static/media/COD.8c654c1b.png";